export default __webpack_public_path__ + "static/media/marker-3-4.3ed7b3e2.png";